export default Object.freeze({
  0: 'Pending',
  1: 'Active',
  2: 'Expired',
  Pending: 0,
  Active: 1,
  Expired: 2
});
